import * as React from "react";

import {observer} from "mobx-react";
import {CSSProperties} from "react";
import {StoreControl, StoreControlProps, StoreControlState} from "shared/controls/base/StoreControl";
import {ValidatorBase} from "shared/utilities/validator/ValidatorBase";
import CodeMirror = require("codemirror");
import {StoreBase} from "shared/utilities/Store/StoreBase";
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/php/php';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/display/autorefresh';
import './Style.css';

export class RNCodeMirror<S extends StoreBase>  extends StoreControl<CodeMirrorProp<S>,CodeMirrorState>{
    static defaultProps: Partial<CodeMirrorProp<any>> = {};
    public node:any;
    public codeMirror:any;


    constructor(props:CodeMirrorProp<S>,state:CodeMirrorState){
        super(props,state);
        this.state={
            ErrorMessage:'',
            IsValid:true
        }
    }


    shouldComponentUpdate(nextProps: Readonly<CodeMirrorProp>, nextState: Readonly<CodeMirrorState>, nextContext: any): boolean {
        return true;
    }

    render() {

        return (
            <div className={'rncontrol'} style={this.props.style}>
                <div>
                    {   this.props.Label!=''&&
                    <label style={{width: '100%', display: 'block'}}>{this.props.Label}</label>
                    }
                    <textarea onChange={()=>{}} ref={(e)=>this.node=e} style={{width:'100%',height:300}} value={this.GetStringValue()}/>
                    {this.GetValidationSection()}
                </div>
            </div>
        )
    }



    componentDidMount(): void {
        super.componentDidMount();
        this.codeMirror = CodeMirror.fromTextArea(this.node, {
            extraKeys: {"Ctrl-Space": "autocomplete"},
            lineNumbers: true,
            matchBrackets: true,
            autoRefresh: true,
            mode: "application/x-httpd-php",
            gutters: ["CodeMirror-lint-markers"],
            lint:true} as any);

        this.codeMirror.on('changes', (instance, change) => {

            this.SetValue(instance.doc.getValue())
        });
    }

    GetValidators(): ValidatorBase[] {
        return [];
    }
}

export interface CodeMirrorProp<S extends StoreBase =any> extends StoreControlProps<S>{
    Label:string;
    style?: CSSProperties;
}

export interface CodeMirrorState extends StoreControlState{

}
